<template>
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 5.62 9.59"
    aria-hidden="true"
  >
    <path d="M3.17 4.81L0 9.59h2.52l3.11-4.78L2.52 0H0l3.17 4.81z" />
  </svg>
</template>
